export const allErrorsTouched = (errorArray, touchedObject) => {
  let result = true;
  errorArray.forEach((error) => {
    if (touchedObject[error] === false || touchedObject[error] === undefined) {
      result = false;
    }
  });
  return result;
};
